<template>
  <sdui-loader v-if="$wait.waiting('fetch-absence-history')" class="p-5" />
  <SList v-else>
    <user-absence-history-item v-for="item in historyItems"
                               :key="`history-item-${item.updated_at}`"
                               :absence="item"
    />
  </SList>
</template>

<script>
import UserAbsenceHistoryItem from './UserAbsenceHistoryItem.vue'
import Classbooks from 'src/api/classbooks.js'
import SduiLoader from 'src/components/miscellaneous/ui/common/SduiLoader.vue'
import { waitFor } from 'src/config/setup/plugins/waitFor/index.js'

export default {
  name: 'UserAbsenceHistoryModal',
  components: { SduiLoader, UserAbsenceHistoryItem },
  props: {
    absence: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    historyItems: [],
  }),

  methods: {
    fetchAbsenceHistory: waitFor('fetch-absence-history', async function () {
      const res = await Classbooks.getAbsencesHistoryById(this.absence.classbook_id, this.absence.uuid)
      this.historyItems = res.data
    }),
  },

  watch: {},
  created() {
    this.fetchAbsenceHistory()
  },
}
</script>

<style scoped lang="scss">
.absence-history-item {
  box-shadow: inset 0px -1px 0px $color-secondary;
}
</style>
